import { LookupAddress } from '../../event/models/lookup-address';
import { LookupContact } from '../../event/models/lookup-contact';
import { Record } from 'immutable';

const PropertyLookupDetailRecord = Record({
  chain: null,
  brand: null,
  propertyId: null,
  name: null,
  contact: new LookupContact({}),
  address: new LookupAddress({}),
  currency: null,
  subscriber: false,
  manuallyAdded: null,
  statusFlag: null,
  payorType: null
});

export class PropertyLookupDetail extends PropertyLookupDetailRecord {
  chain: string;
  brand: string;
  propertyId: string;
  name: string;
  contact: LookupContact;
  address: LookupAddress;
  currency: string;
  subscriber: boolean;
  manuallyAdded: boolean;
  statusFlag: string;
  payorType: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/property-lookup-detail.ts